import { ERROR_HANDLER, INFO_HANDLER, RESET_ALERT } from '../actions';

const alertReducer = (oldState = {
  errorVm: {
    errorMessage: '',
    infoMessage: '',
    success: null,
  }
}, action) => {
  const { errorVm } = oldState;
  switch (action.type) {
    case ERROR_HANDLER:
    {
      const { errorMessage } = action;
      return {
        ...oldState,
        errorVm: {
          ...errorVm,
          errorMessage,
          success: false
        }
      };
    }
    case INFO_HANDLER:
    {
      const { infoMessage } = action;
      return {
        ...oldState,
        errorVm: {
          ...errorVm,
          infoMessage,
          success: true
        }
      };
    }
    case RESET_ALERT:
      return {
        ...oldState,
        errorVm: {
          ...errorVm,
          infoMessage: '',
          errorMessage: '',
          success: null
        }
      };
    default:
      return oldState;
  }
};

export default alertReducer;



// WEBPACK FOOTER //
// ./src/pages/alertReducer.js